import { render, staticRenderFns } from "./FieldUsecases.vue?vue&type=template&id=38a46341&scoped=true&"
import script from "./FieldUsecases.vue?vue&type=script&lang=js&"
export * from "./FieldUsecases.vue?vue&type=script&lang=js&"
import style0 from "./FieldUsecases.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FieldUsecases.vue?vue&type=style&index=1&id=38a46341&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a46341",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
